import React from 'react';
import { PostAttachmentProps } from '../../NewsfeedModels';
import { Text, Paper, Colors } from 'library';
import CalendarAvailability from 'parent-portal/provider-profile/availability/CalendarAvailability';
import AvailabilityPost from 'models/AvailabilityPost';

export default function Availability({ content }: PostAttachmentProps<AvailabilityPost>) {
    return (
        <Paper padding={10}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 10 }}>
                <CalendarAvailability provider={content.provider} />
            </div>
        </Paper>
    );
}
